import React, { useEffect } from "react";
import { Modal, Form, Input, Button, notification } from "antd";

const CreateSafetyCategoryModal = ({
  visible,
  onClose,
  onCategoryCreated,
  existingCategories = [],
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = (values) => {
    const category = (values.category || "").trim();
    if (!category) {
      notification.error({
        message: "Category required",
        description: "Please enter a category name.",
      });
      return;
    }

    const exists = existingCategories.some(
      (item) => item.toLowerCase() === category.toLowerCase()
    );
    if (exists) {
      const matched = existingCategories.find(
        (item) => item.toLowerCase() === category.toLowerCase()
      );
      notification.info({
        message: "Category already exists",
        description: `"${matched}" is already in the list.`,
      });
      onCategoryCreated?.(matched || category);
      handleClose();
      return;
    }

    onCategoryCreated?.(category);
    handleClose();
  };

  return (
    <Modal
      title="Create Category"
      open={visible}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
      zIndex={1200}
      centered
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="category"
          label="Category"
          rules={[{ required: true, message: "Please enter a category" }]}
        >
          <Input placeholder="e.g. PPE" autoFocus />
        </Form.Item>
        <Form.Item className="mb-0">
          <div className="flex justify-end gap-2">
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateSafetyCategoryModal;
